import { EvidenceCard } from '@/components/citations';
import type { DetailedPoliceReport } from '@/services/api/generated/policeReportsService';

interface EvidenceSectionProps {
  report: DetailedPoliceReport;
  matterId: string;
}

export const EvidenceSection = ({ report, matterId }: EvidenceSectionProps) => {
  // Get all unique extractions from all suggestions
  const allExtractions =
    report.suggestions?.flatMap((suggestion) => suggestion.extractions || []) ||
    [];

  // Deduplicate by extraction ID
  const uniqueExtractions = allExtractions.filter(
    (extraction, index, array) =>
      array.findIndex((e) => e.id === extraction.id) === index,
  );

  if (uniqueExtractions.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg
              className="h-5 w-5 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-gray-800">
              No Sources Found
            </h3>
            <p className="mt-1 text-sm text-gray-600">
              This police report doesn&apos;t have any associated sources or
              citations yet.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <h2 className="text-lg font-medium text-gray-900">Sources</h2>
      <div className="space-y-6">
        {uniqueExtractions.map((extraction, index) => (
          <div key={extraction.id} className="space-y-3">
            <div className="flex items-center gap-2">
              <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs font-medium">
                Source #{index + 1}
              </span>
            </div>
            <EvidenceCard
              evidence={{
                artifact_id:
                  extraction.artifact_id ||
                  extraction.citations?.[0]?.artifact_id,
                citation_ids:
                  extraction.citations
                    ?.map((c) => c.citation_id)
                    .filter((id): id is string => Boolean(id)) || [],
                context: `${extraction.extra?.context}`,
                created_at: extraction.created_at,
                // rationale: extraction.extra?.reasoning,
                // confidence: extraction.extra?.confidence,
              }}
              matterId={matterId}
              showTimestamp
            />
          </div>
        ))}
      </div>
    </>
  );
};
